import type { ReactNode, Ref } from 'react';
import classes from './FormMessage.module.css';

interface FormMessageProps {
  /** `error` — красная линия и `role="alert"`; `info` — зелёная линия и `role="status"`. */
  readonly tone?: 'error' | 'info';
  readonly title?: string;
  /** Без живой области: справочный текст, который появляется вместе с данными, а не в ответ на действие. */
  readonly quiet?: boolean;
  readonly children: ReactNode;
  /** Чтобы после неудачной отправки перевести на сообщение фокус. */
  readonly ref?: Ref<HTMLDivElement>;
}

// Сообщение формы («Бюллетень»): текст с цветной линией слева, без заливки и плашки. Фокус переводится сюда
// после неудачной отправки, поэтому блок принимает фокус программно (tabIndex -1), но не по Tab.
export default function FormMessage({ tone = 'error', title, quiet = false, children, ref }: FormMessageProps) {
  return (
    <div
      ref={ref}
      tabIndex={-1}
      role={quiet ? undefined : tone === 'error' ? 'alert' : 'status'}
      className={`${classes.message} ${tone === 'error' ? classes.error : classes.info}`}
    >
      {title ? <p className={classes.title}>{title}</p> : null}
      {children}
    </div>
  );
}
